import {Heading } from "grommet";

const GroupHeader = (props) => {
  return (
    <Heading
      level={2}
      color={"#2f4858"}
      //margin={{ top: "medium", bottom: "small" }}
    >
      {props.children}
    </Heading>
  );
};

export default GroupHeader;
